document.addEventListener("DOMContentLoaded", () => {

  /* =====================================
     Reading Progress
  ====================================== */

  const progressBar = document.querySelector(".nf-progress-bar");

  function updateProgress() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const percent = height > 0 ? (scrollTop / height) * 100 : 0;

    if (progressBar) {
      progressBar.style.width = percent + "%";
    }
  }

  updateProgress();
  window.addEventListener("scroll", updateProgress, { passive: true });

  /* =====================================
     Generate Table of Contents
  ====================================== */
/*
  const article = document.querySelector("#article-content");
  const toc = document.querySelector("#toc-list");

  function makeSlug(text, index, usedSlugs) {
    let base = (text || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[\u0591-\u05C7]/g, "")
      .replace(/[^\u0590-\u05FFa-z0-9]+/gi, "-")
      .replace(/(^-|-$)/g, "");

    if (!base) base = "heading-" + index;

    let slug = base;
    let count = 2;

    while (usedSlugs.has(slug) || document.getElementById(slug)) {
      slug = base + "-" + count;
      count++;
    }

    usedSlugs.add(slug);
    return slug;
  }

  if (article && toc) {
    toc.innerHTML = "";

    const headings = article.querySelectorAll(
      ":scope > h2, :scope > h3, :scope .blog-inline-products > h2, :scope .blog-faq-heading > h2"
    );

    const usedSlugs = new Set();

    headings.forEach((heading, index) => {
      if (!heading.id || document.querySelectorAll("#" + CSS.escape(heading.id)).length > 1) {
        heading.id = makeSlug(heading.innerText, index, usedSlugs);
      } else {
        usedSlugs.add(heading.id);
      }

      const li = document.createElement("li");
      const link = document.createElement("a");

      link.href = "#" + heading.id;
      link.innerText = heading.innerText;

      if (heading.tagName === "H3") {
        link.classList.add("toc-sub");
      }

      li.appendChild(link);
      toc.appendChild(li);
    });
  }

  /* =====================================
     Smooth Scroll for TOC
  ====================================== */
/*
  document.addEventListener("click", function (e) {
    const link = e.target.closest("#toc-list a");
    if (!link) return;

    e.preventDefault();

    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - 110,
      behavior: "smooth"
    });
  });

  /* =====================================
     Active Heading
  ====================================== */
/*
  const sections = document.querySelectorAll(
    "#article-content > h2, #article-content > h3, #article-content .blog-inline-products > h2, #article-content .blog-faq-heading > h2"
  );

  if (sections.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          document.querySelectorAll("#toc-list a").forEach((a) => {
            a.classList.remove("active");

            if (a.getAttribute("href") === "#" + entry.target.id) {
              a.classList.add("active");
            }
          });
        });
      },
      { rootMargin: "0px 0px -70% 0px" }
    );

    sections.forEach((section) => observer.observe(section));
  }

  /* =====================================
     Copy Link
  ====================================== */

/* =====================================
   Generate Table of Contents
====================================== */

const article = document.querySelector("#article-content");
const toc = document.querySelector("#toc-list");

function makeSlug(text, index, usedSlugs) {
  let base = (text || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\u0591-\u05C7]/g, "")
    .replace(/[^\u0590-\u05FFa-z0-9]+/gi, "-")
    .replace(/(^-|-$)/g, "");

  if (!base) base = "heading-" + index;

  let slug = base;
  let count = 2;

  while (usedSlugs.has(slug) || document.getElementById(slug)) {
    slug = base + "-" + count;
    count++;
  }

  usedSlugs.add(slug);
  return slug;
}

if (article && toc) {
  toc.innerHTML = "";

  /*
    Find ALL H2 and H3 headings inside the article,
    regardless of how deeply they are nested.
  */
  const headings = article.querySelectorAll("h2, h3");

  const usedSlugs = new Set();

  headings.forEach((heading, index) => {

    // Ignore empty headings
    const headingText = heading.innerText.trim();

    if (!headingText) return;

    // Create unique ID
    if (
      !heading.id ||
      document.querySelectorAll("#" + CSS.escape(heading.id)).length > 1
    ) {
      heading.id = makeSlug(headingText, index, usedSlugs);
    } else {
      usedSlugs.add(heading.id);
    }

    // Create TOC item
    const li = document.createElement("li");
    const link = document.createElement("a");

    link.href = "#" + heading.id;
    link.innerText = headingText;

    if (heading.tagName === "H3") {
      link.classList.add("toc-sub");
    }

    li.appendChild(link);
    toc.appendChild(li);
  });
}


/* =====================================
   Smooth Scroll for TOC
====================================== */

document.addEventListener("click", function (e) {

  const link = e.target.closest("#toc-list a");

  if (!link) return;

  e.preventDefault();

  const target = document.querySelector(link.getAttribute("href"));

  if (!target) return;

  window.scrollTo({
    top: target.getBoundingClientRect().top + window.pageYOffset - 110,
    behavior: "smooth"
  });

});


/* =====================================
   Active Heading
====================================== */

const sections = document.querySelectorAll(
  "#article-content h2, #article-content h3"
);

if (sections.length) {

  const observer = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        document.querySelectorAll("#toc-list a").forEach((a) => {

          a.classList.remove("active");

          if (
            a.getAttribute("href") === "#" + entry.target.id
          ) {
            a.classList.add("active");
          }

        });

      });

    },
    {
      rootMargin: "0px 0px -70% 0px"
    }
  );

  sections.forEach((section) => observer.observe(section));
}

  const copyButton = document.querySelector(".copy-link");

  if (copyButton) {
    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText(window.location.href);
      copyButton.innerHTML = "Copied!";

      setTimeout(() => {
        copyButton.innerHTML = "Copy";
      }, 2000);
    });
  }

  /* =====================================
     FAQ Accordion
  ====================================== */

  document.querySelectorAll(".faq-question").forEach((button) => {
    button.addEventListener("click", function () {
      const item = this.parentElement;
      item.classList.toggle("active");
    });
  });

/* =====================================
   Inline Blog Collection Carousel - RTL Hebrew
   Fixed direction + loop
====================================== */

document.querySelectorAll("[data-blog-carousel]").forEach((carousel) => {
  const track = carousel.querySelector(".nf-blog-carousel__track");
  const leftBtn = carousel.querySelector("[data-carousel-left]");
  const rightBtn = carousel.querySelector("[data-carousel-right]");

  if (!track || !leftBtn || !rightBtn) return;

  function getScrollAmount() {
    const slide = track.querySelector(".nf-blog-carousel__slide");
    if (!slide) return 300;

    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || "0") || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function getMaxScroll() {
    return 0;
  }

  function getMinScroll() {
    return track.clientWidth - track.scrollWidth;
  }

  function hasOverflow() {
    return track.scrollWidth > track.clientWidth + 5;
  }

  function scrollToPosition(position) {
    track.scrollTo({
      left: position,
      behavior: "smooth"
    });
  }

  function scrollByAmount(amount) {
    track.scrollBy({
      left: amount,
      behavior: "smooth"
    });
  }

  function updateCarouselState() {
    const overflow = hasOverflow();

    carousel.classList.toggle("has-overflow", overflow);

    /* Client wants arrows always clickable, so never disable */
    leftBtn.classList.remove("is-disabled");
    rightBtn.classList.remove("is-disabled");

    leftBtn.disabled = false;
    rightBtn.disabled = false;
  }

  /*
    RTL logic:
    Right arrow should move to next products.
    Left arrow should move back.
    In RTL scroll containers, next direction is negative scrollLeft.
  */

  rightBtn.addEventListener("click", function () {
    if (!hasOverflow()) return;

    const amount = getScrollAmount();
    const minScroll = getMinScroll();
    const current = track.scrollLeft;

    /* If already at the end, loop back to start */
    if (current <= minScroll + 8) {
      scrollToPosition(getMaxScroll());
    } else {
      scrollByAmount(-amount);
    }
  });

  leftBtn.addEventListener("click", function () {
    if (!hasOverflow()) return;

    const amount = getScrollAmount();
    const maxScroll = getMaxScroll();
    const current = track.scrollLeft;

    /* If already at the start, loop to end */
    if (current >= maxScroll - 8) {
      scrollToPosition(getMinScroll());
    } else {
      scrollByAmount(amount);
    }
  });

  track.addEventListener("scroll", function () {
    window.requestAnimationFrame(updateCarouselState);
  }, { passive: true });

  window.addEventListener("resize", updateCarouselState);

  updateCarouselState();
});

/* =====================================
   Bottom Featured Products Slider
   RTL direction kept same + loop fixed
====================================== */

document.querySelectorAll(".blog-featured-slider-wrapper").forEach((wrapper) => {
  const slider = wrapper.querySelector(".blog-featured-slider");
  const next = wrapper.querySelector(".blog-slider-next");
  const prev = wrapper.querySelector(".blog-slider-prev");

  if (!slider || !next || !prev) return;

  function getFeaturedAmount() {
    const slide = slider.querySelector(".blog-product-slide");
    if (!slide) return 300;

    const style = window.getComputedStyle(slider);
    const gap = parseFloat(style.columnGap || style.gap || "0") || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function hasOverflow() {
    return slider.scrollWidth > slider.clientWidth + 5;
  }

  function getStartScroll() {
    return 0;
  }

  function getEndScroll() {
    return slider.clientWidth - slider.scrollWidth;
  }

  function scrollToPosition(position) {
    slider.scrollTo({
      left: position,
      behavior: "smooth"
    });
  }

  function scrollByAmount(amount) {
    slider.scrollBy({
      left: amount,
      behavior: "smooth"
    });
  }

  function keepButtonsActive() {
    prev.classList.remove("is-disabled");
    next.classList.remove("is-disabled");

    prev.disabled = false;
    next.disabled = false;
  }

  /*
    Keep existing correct direction:
    Next = negative scroll
    Prev = positive scroll
  */

  next.addEventListener("click", function () {
    if (!hasOverflow()) return;

    const amount = getFeaturedAmount();
    const current = slider.scrollLeft;
    const end = getEndScroll();

    /* If already at end, loop back to start */
    if (current <= end + 8) {
      scrollToPosition(getStartScroll());
    } else {
      scrollByAmount(-amount);
    }

    keepButtonsActive();
  });

  prev.addEventListener("click", function () {
    if (!hasOverflow()) return;

    const amount = getFeaturedAmount();
    const current = slider.scrollLeft;
    const start = getStartScroll();

    /* If already at start, loop to end */
    if (current >= start - 8) {
      scrollToPosition(getEndScroll());
    } else {
      scrollByAmount(amount);
    }

    keepButtonsActive();
  });

  slider.addEventListener("scroll", function () {
    window.requestAnimationFrame(keepButtonsActive);
  }, { passive: true });

  window.addEventListener("resize", keepButtonsActive);

  keepButtonsActive();
});

/* =====================================
   Mobile TOC Toggle
====================================== */

const tocCard = document.querySelector(".blog-toc-card");
const tocTitle = document.querySelector(".blog-toc-title");

if (tocCard && tocTitle) {
  tocTitle.addEventListener("click", function () {
    if (window.innerWidth <= 749) {
      tocCard.classList.toggle("is-open");
    }
  });
}

});

document.querySelectorAll(".cart-product-description").forEach(function (desc) {
    const words = desc.textContent.trim().split(/\s+/);

    if (words.length > 5) {
        desc.textContent = words.slice(0, 5).join(" ") + "...";
    }
});

/* =====================================
   Move Cart Inside .cardcolbot
====================================== */

document.querySelectorAll(".nf-ref-product-card").forEach((card) => {

    const cart = card.querySelector(".recepodhover");
    const cardBottom = card.querySelector(".cardcolbot");

    if (!cart || !cardBottom) return;

    // Move cart to the top of .cardcolbot
    cardBottom.insertAdjacentElement("afterbegin", cart);

});